














































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TramiteCambioJefeHogar from "@/models/tramite/cambio-jefe-hogar/cambioJefeHogar.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import { CambioJefeHogarRazon } from "@/enums/CambioJefeHogarRazon";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";

@Component({
  components: { DatePickerComponent }
})
export default class CambioJefeHogar extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;

  // @Prop() readonly hogarId!: number;
  @Prop() readonly razon!: CambioJefeHogarRazon;
  @Prop() readonly content!: TramiteBeneficiario;

  CambioJefeHogarRazon = CambioJefeHogarRazon;
  constructor() {
    super();
  }

  jefePropuesto: Miembro | null | undefined = null;
  jefeActual: Miembro | null = null;
  miembroTableConfig: BTableConfig<Miembro> | null = null;
  model = new TramiteCambioJefeHogar();
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
  get jefeActualPersona() {
    return this.jefeActual ? this.jefeActual.persona : null;
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp("razon", "string", true, "Razón de cambio")
    );
    this.$emit("render", props);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.tramiteCambioJefeHogar)
        delete contenido.tramiteCambioJefeHogar;

      this.$emit("update:content", contenido);
    }
  }
  onSelect(selected: Miembro, oldSelected: Miembro) {
    this.jefePropuesto = this.map<Miembro>(selected);
    this.model.jefeHogarId = selected.id;
  }
  unSelectJefePropuesto() {
    (this.jefePropuesto as Miembro).persona = undefined;
    (this.miembroTableConfig as BTableConfig<
      Miembro
    >).selection.selected = null;
    this.model.jefeHogarId = undefined;
  }
  onLoadTable(config: BTableConfig<Miembro>) {
    this.miembroTableConfig = config;
  }
  @Watch("model", { deep: true })
  async onModelChange(value: TramiteCambioJefeHogar) {
    let contenido = this.content as any;
    if (contenido) {
      if (value.jefeHogarId) {
        contenido.tramiteCambioJefeHogar = value;
        contenido.tramiteCambioJefeHogar.razon =
          this.razon || this.tipoTramite.nombre;

          contenido.tramiteCambioJefeHogar.jefeAnteriorId = (this.jefeActual as any).personaId;
      } else {
        delete contenido.tramiteCambioJefeHogar;
      }
      this.$emit("update:content", contenido);
    }
  }
}
